<template>
	<search-view class="customer-search-view" :value="$attrs.value" :label="$attrs.label" @input="input" :search="search" :mapName="mapName" :mapId="mapId" :read="read" :create="create" />
</template>

<script>
	import SearchView from './SearchView';
	import customer from '../../model/customer';

	export default {
		components: {
			SearchView
		},
		methods: {
			async search(input) {
				return await customer.search({
					cache: input
				});
			},
			async mapName(item) {
				var p = [item.name];
				if (item.vat) p.push(`CVR ${item.vat}`);
				if (item.ean) p.push(`EAN ${item.ean}`);
				if (item.city) p.push(`${item.city}`);

				return p.join(', ');
			},
			async mapId(item) {
				return item.id;
			},
			async read(id) {
				return await customer.read(id);
			},
			async create(input) {
				const self = this;

				customer.open({
					name: input
				}, (model) => {
					self.$emit('input', model.id);
				});
			},

			input(val) {
				console.log('inpout', val);
				this.$emit('input', val);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.customer-search-view {
		
	}
</style>